var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisible)?_c('GmapMarker',{attrs:{"position":_vm.position,"icon":_vm.assetIcon,"options":{ visible: _vm.isVisible, zIndex: 100 },"clickable":""},on:{"click":function($event){return _vm.openVehicleMarkerInfo(_vm.item)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }